import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Alert from '@mui/material/Alert';
import Section from 'components/Section';
import FlightPriceHistoryTable from 'components/FlightPriceHistoryTable';

import { PackageDateEditFlightPriceHistory_flight$key } from '__generated__/PackageDateEditFlightPriceHistory_flight.graphql';

type Props = {
  flight: PackageDateEditFlightPriceHistory_flight$key;
};

const PackageDateEditFlightPriceHistory: FC<Props> = props => {
  const { history } = useFragment(
    graphql`
      fragment PackageDateEditFlightPriceHistory_flight on Flight {
        history(first: 10, onlyPriceChanged: true) {
          ...FlightPriceHistoryTable_history

          pageInfo {
            total
          }
        }
      }
    `,
    props.flight
  );

  return (
    <Section id="flightPriceHistory" title="Skrydžio kainos istorija">
      {history && history.pageInfo.total > 0 ? (
        <FlightPriceHistoryTable
          hideToolbar
          hideNotes
          pagination={false}
          history={history}
        />
      ) : (
        <Alert severity="info">Skrydžių kainos istorijos dar nėra</Alert>
      )}
    </Section>
  );
};

export default PackageDateEditFlightPriceHistory;
